"use client";

import { useCompare } from "@/lib/compare-store";
import type { Locale } from "@/types/units";
import { useLocale } from "next-intl";

/** Compare page header — title, hint, currency switch and clear. */
export default function CompareHeader() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  const compare = useCompare();

  return (
    <header className="mx-auto flex max-w-360 flex-col justify-between gap-6 border-b border-black/10 px-6 py-14 md:flex-row md:items-end lg:px-10 dark:border-white/10">
      <div>
        <div className="mb-4 text-[11px] font-semibold uppercase tracking-widest text-accent">
          © {ar ? "مقارنة" : "Compare"}
        </div>
        <h1 className="font-bebas text-[clamp(2.5rem,6vw,5rem)] uppercase leading-none text-ash dark:text-white">
          {ar ? "مقارنة الوحدات" : "Compare Units"}
        </h1>
        <p className="mt-3 text-[11px] uppercase tracking-widest text-ash/50 dark:text-white/50">
          {ar ? "اختر حتى ٣ وحدات" : "Select up to 3 units"}
        </p>
      </div>

      <div className="flex flex-wrap items-center gap-4">
        {compare.codes.length > 0 && (
          <button
            onClick={compare.clear}
            className="h-11 border border-black/20 px-8 text-[11px] font-semibold uppercase tracking-widest text-ash transition-colors hover:bg-ash hover:text-white dark:border-white/20 dark:text-white dark:hover:bg-white dark:hover:text-ash"
          >
            {ar ? "مسح الكل" : "Clear all"}
          </button>
        )}
      </div>
    </header>
  );
}
